/* eslint-disable react/no-array-index-key */
import { Link } from 'react-router-dom';
import Status from './Status';

// HOC => Component that manipulate it's child
function StatusWithoutBackground(props) {
  const { status } = props;

  return (
    <div className="tags_container">
      {status?.map(({ statusText, link }, index) => (
        <Status
          text={<Link to={link || ''}>{statusText}</Link>}
          progress="tags"
          key={`status-${index}`}
        />
      ))}
    </div>
  );
}

export default StatusWithoutBackground;
